/**
 * Humanise a tag key into a display label. Mirrors the helper used by
 * riu_company_admin (DataManagment/Quantative/component/answerHistoryPage/
 * components/utils.js) so the cascade reads the same on both apps.
 */
export const formatKey = (key) => {
  if (!key) return "";

  const map = {
    module: "Module",
    subcategory: "Sub Category",
    kpi: "KPI",
    category: "Category",
    scope: "Scope",
  };

  const normalized = key.toLowerCase().replace(/\s+/g, "");

  if (map[normalized]) return map[normalized];

  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
};
